import { Component } from 'preact';
import { Link } from 'preact-router/match';
import { Stateful } from '@components/pubsub';
import I18n from '@i18n';
import MobileNav from '@components/mobile-nav';
import Portal from 'preact-portal';

import style from './style';

class MobileHeader extends Component {
  state = {
    navOpen: false,
  };

  toggleNav = () => {
    this.setState({ navOpen: !this.state.navOpen });
  };

  render({ dark = true, ...props }, state, { lang }) {
    return (
      <div class={`${style.mobileHeader} ${dark ? style.dark : style.light}`}>
        {/* Left aligned hamburger button */}
        <div class={style.hamburgerWrapper}>
          <button
            class={`${style.hamburgerButton} ${
              state.navOpen ? style.open : ''
            }`}
            onClick={this.toggleNav}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Center aligned text logo */}
        <div class={style.logoWrapper}>
          <a href={`/${lang}`} class={style.logo}>
            <img
              height="20"
              class={style.tableOnlineLogo}
              src={
                dark
                  ? '/assets/images/logo-text-white.png'
                  : '/assets/images/logo-text-black.png'
              }
              alt="TableOnline Logo"
            />
          </a>
        </div>

        {/* Right aligned search and account icons */}
        <div class={style.actionsWrapper}>
          {/* Search Icon */}
          <Link
            href={`/${lang}/search`}
            class={style.actionButton}
            aria-label="Search"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </Link>

          {/* Divider */}
          <div class={style.divider}></div>

          {/* Account Icon */}
          <Stateful events={['auth']}>
            {({ auth }) => (
              <Link
                href={`/${lang}/profile`}
                class={style.actionButton}
                aria-label={auth ? auth.firstname : 'Profile'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </Link>
            )}
          </Stateful>
        </div>

        {/* Render MobileNav in a Portal to document.body */}
        <Portal into="body">
          <MobileNav
            isOpen={state.navOpen}
            onClose={() => this.setState({ navOpen: false })}
          />
        </Portal>
      </div>
    );
  }
}

export default MobileHeader;



// WEBPACK FOOTER //
// ./components/mobile-header/index.js